import { useConfig } from '@kikoda/generated-config-hooks';
import axios from 'axios';
import { WebConfig } from '~/web-config';
import { useUser } from '../useUser';

async function resetUsersPw(token: any, apiEndpoint: string, users: string[]): Promise<void> {
  if (!token) return;
  try {
    const api = axios.create();
    await api.post(
      `${apiEndpoint}/portal/users/recover`,
      {
        users: users,
      },
      {
        headers: {
          Authorization: token,
        },
      },
    );
  } catch (error) {
    console.debug('Error deleting user', error);
  } finally {
    return;
  }
}

export const useResetTenantUsersPw = () => {
  const config = useConfig<WebConfig>();
  const { user } = useUser();
  const { tenantServiceEndpoint } = config?.additionalConfig?.platform?.backend;

  const resetTenantUsersPw = async (users: string[]) => {
    await resetUsersPw(
      user?.getSignInUserSession()?.getIdToken().getJwtToken(),
      tenantServiceEndpoint,
      users,
    );
  };

  return { resetTenantUsersPw };
};
